module.exports = __webpack_public_path__ + "5cc6a9719864406ea87a6224ae1551e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/trophy.svg
// module id = 2820
// module chunks = 1